//import green from '@material-ui/core/colors/green';

import {createHashHistory} from 'history';

const _DESENVOLVIMENTO = 'DESENVOLVIMENTO'; 

let _ENV = 'PRODUCAO'; //ALTERAR PARA PRODUCAO NO SERVIDOR

// cria o hashHistory para navegação e roteamento de páginas da aplicação
export const myHistory = createHashHistory();

// ajuda na especificacao de configuracao de dev ou prod
const dp = (dev:any, prod:any) => {
    return _ENV === _DESENVOLVIMENTO ? dev : prod;
}

export const niveisAcesso = {'ADMINISTRADOR': 'Administrador', 'TECNICO': 'Técnico', 'COMUM': 'Comum'};

// ajuda na especificachistory

const url_api = dp("http://localhost:5000/pragas/bayer","https://geoservices.cnpm.embrapa.br/api/bayer_services/bayer");

const config = {
    title_app: "Bayer",
    
    token_dev: "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ1c3VhcmlvIjoiZGF2aWN1c3RvZGlvIiwiaWF0IjoxNTgyMTE4MTkxLCJleHAiOjE2Njg1MTgxOTF9.lhZ2YpqAr3m-Z9WBdAvc1e_Ub0pRaqrhHxtkc3iItCU",
    //token_dev: "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ1c3VhcmlvIjoiZGF2aWN1c3RvZGlvIiwiaWF0IjoxNTg1MzIxOTQxLCJleHAiOjE2NzE3MjE5NDF9.Z64weqoFnNXbEkVDL8Py9UCdLChJjIb_LEa4ICGuu7w",
    // chave para o cookie de login^M
    
    key_login_cookie            : 'monitora_oeste_pragas',
    time_login_cookie_in_hours  : 72,
   
    url_cidades_list: url_api + "/lista_cidades",

    url_estados_list: url_api + "/lista_estados",

    url_lista_ocorrencias : url_api + "/lista_ocorrencias"

}

export default config;